import { firstValueFrom } from "rxjs";
import { api } from "../../common/api/index.ts";
import { LoginStatus } from "../../common/types.ts";
import { loginStatus$ } from "../store/loginV2.ts";

const doGenerateTopic = api.path("/api/topic").method("post").create();

export async function generateTopic(): Promise<string> {
	const loginStatus = await firstValueFrom(loginStatus$);
	if (loginStatus.status !== LoginStatus.LOGGED_IN) {
		throw new Error("User is not logged in, cannot generate topic");
	}
	const response = await doGenerateTopic(
		{},
		{
			headers: {
				authorization: `Bearer ${loginStatus.token}`,
				"content-type": "",
			},
		},
	);
	return response.data.topic;
}
